import { Component,ViewChild } from '@angular/core';
import { ShareButtonComponent } from 'src/app/share-button/share-button.component';
@Component({
  selector: 'app-creating-profile',
  templateUrl: './creating-profile.component.html',
  styleUrls: ['./creating-profile.component.css']
})
export class CreatingProfileComponent {
  dropdown: boolean = true;
  searchbar: boolean = false;
  colors:string='1';
  showTable: boolean = false;
  value: string = 'Payment Gateway';
  storemanu: string = 'Payment Gateway';
  @ViewChild(ShareButtonComponent) shareButton!: ShareButtonComponent;
  openShareOptions() {      
    this.shareButton.setData(true)   ;
  }

  process:string[]=['E-commerce Websites','Online Marketplace','Mobile Apps','Point of Sale (POS) Systems','Subscription Services','Donation Platforms ','Online Booking Platforms','Government Websites ','Educational Institutions ','Peer-to-Peer Transactions ','Telecommunications ','Gaming and Entertainment ','Digital Downloads ','Cross-Border Transactions ','Charitable Organizations ']; 
  menutype(event: any) {
    this.value = event.target.value;
    this.showTable = false;
  }

  search() {
    this.dropdown = false;
    this.searchbar = true;
  }
  drop() {
    this.dropdown = true;
    this.searchbar = false;
  }
  menues(event: string) {
    this.value = event;


  }
  closemenu: boolean = false;
  child: string = '';
  subMenu(sub: string) {
    this.child = sub;
    if (this.child == '1') {

      this.up = false;
      this.down = true;

    }
    if (this.child == '2') {

      this.up1 = false;
      this.down1 = true;

    }
    if (this.child == '3') {

      this.up2 = false;
      this.down2 = true;

    }

  }
  up: boolean = true;
  down: boolean = false;
  up1: boolean = true;
  down1: boolean = false;
  up2: boolean = true;
  down2: boolean = false;
  close() {
    this.child = '';
    this.up = true;
  
}

showcolor:boolean | undefined;
showcl:string="";
  showpayment(show:boolean,val:string){
this.showcolor=show;
this.showcl=val;
if(this.showcolor==true && this.showcl=='1')
{
this.colors="1";
}
if(this.showcolor==true && this.showcl=='2')
{
this.colors="2";
}
if(this.showcolor==true && this.showcl=='3')
{
this.colors="3";
}
if(this.showcolor==true && this.showcl=='4')
{
this.colors="4";
}
if(this.showcolor==true && this.showcl=='5')
{
this.colors="5";
}




}
color(cl:string)
{
  var co = cl;
  this.colors=co;
}

}
